import { Tooltip } from 'antd';
import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

// Handlers an Ant Design trigger injects (tooltip, popover) pass through to the dot.
type Props = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & { tooltip?: { title: ReactNode } };

export const Indicator = ({ tooltip, className, ...props }: Props) =>
    tooltip ? (
        <Tooltip title={tooltip.title}>
            <div className={clsx('size-4 rounded-full', className)} {...props} />
        </Tooltip>
    ) : (
        <div className={clsx('size-4 rounded-full', className)} {...props} />
    );
